import React, { useState } from "react";
import { Link } from "react-router-dom";
import WIIASCEND from "../assets/images/wiiascend.png";
import Contact from "../pages/Contact";
import OptionModal from "./OptionsModal";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicosMenuOpen, setIsServicosMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleServicosMenu = () => setIsServicosMenuOpen(!isServicosMenuOpen);
  const openModal = () => setIsModalOpen(true);
  const openMainModal = () => setIsMainModalOpen(true);

  const closeModal = () => setIsModalOpen(false);
  const closeMainModal = () => setIsMainModalOpen(false);
  const closeServicosModal = () => setIsServicosMenuOpen(false);
  return (
    <>
      <div
        className="hidden lg:flex  h-auto w-fit min-w-[300px] mt-10 lg:flex-row items-center justify-around lg:justify-between min-h-16 px-8 top-0 left-0 right-0 z-10 gap-8 transition-all duration-300"
        style={{
          background: "rgba(8, 21, 51, 0.40)",
          backdropFilter: "blur(12.5px)",
          borderRadius: "79.5px",
          border: "1.5px solid rgba(21, 83, 224, 0.60)",
        }}
      >
        <div>
          <img
            src={WIIASCEND}
            alt="WIIASCEND"
            className="w-[150px] pl-2 justify-end h-auto"
          />
        </div>
        <div className="flex flex-row justify-end w-[700px] mr-5">
          {/* nav */}
          <div className="items-center justify-end">
            <nav className={` hidden lg:flex gap-4 items-center`}>
              <Link to="/" className="text-white hover:text-[#887443]">
                Início
              </Link>
              <Link to="/we" className="text-white hover:text-[#887443]">
                Sobre Nós
              </Link>

              <button
                id="dropdownDelayButton"
                data-dropdown-toggle="dropdownDelay"
                onClick={toggleServicosMenu}
                data-dropdown-delay="300"
                data-dropdown-trigger="hover"
                class=" bg-transparent px-4 py-3 rounded-full text-md  text-center text-[#887443] inline-flex items-center"
                type="button"
              >
                Serviços
              </button>
            </nav>
          </div>
          <div className="flex flex-row justify-between items-center w-[300px]">
            <div className="hidden lg:flex ">
              <a
                onClick={openMainModal}
                className="bg-[#9B7B2F] text-white w-[180px] h-fit py-2 px-6 rounded-full mr-4 overflow-visible hover:bg-[#7A5F22] cursor-pointer select-none"
              >
                Entrar em contato
              </a>
            </div>
            <div className="hidden lg:flex">
              <a
                target="_blank"
                href="https://banking.wiiascend.com/"
                className="bg-white h-fit  px-10 py-2 border border-[#1553E099] text-black rounded-full hover:text-black hover:bg-[#d9d9d9]"
              >
                Login
              </a>
            </div>
          </div>
        </div>
      </div>

      {isServicosMenuOpen && (
        <div
          id="dropdown"
          class="flex flex-col bg-[#112d6f] h-20 ml-45 p-5 items-left rounded-lg shadow-sm w-40"
        >
          <Link to="/cripto" className="text-white hover:text-[#887443]">
            Exchange
          </Link>
          <Link to="/token" className="text-white hover:text-[#887443]">
            Investimento
          </Link>
        </div>
      )}

      <div
        className={`lg:hidden md:flex xl:hidden 2xl:hidden flex flex-col h-fit w-fit min-w-[300px] mb-1 my-10 flex items-center justify-around min-h-16 top-0 left-0 right-0 z-10 gap-1 transition-all duration-100 ${
          isMenuOpen ? "h-auto" : "h-16"
        }`}
        style={{
          background: "rgba(8, 21, 51, 0.40)",
          backdropFilter: "blur(12.5px)",
          borderRadius: isMenuOpen ? "50.5px" : "79.5px",
          border: "1.5px solid rgba(21, 83, 224, 0.60)",
        }}
      >
        <div className="flex flex-row items-center justify-around ">
          <div className="lg:hidden cursor-pointer " onClick={toggleMenu}>
            {!isMenuOpen && (
              <span className="text-[#887443] font-bold text-2xl">☰</span>
            )}
            {isMenuOpen && (
              <span className="text-[#887443] font-bold text-3xl">×</span>
            )}{" "}
          </div>

          <div>
            <img
              src={WIIASCEND}
              alt="WIIASCEND"
              className="w-[150px] pl-2 justify-end h-auto rounded-xl"
            />
          </div>
        </div>

        {isMenuOpen && (
          <div className="flex flex-col  items-left text-white w-full bg-transparent py-4 rounded-3xl lg:hidden ">
            <Link
              to="/"
              className="block px-10 py-2  text-white font-bold hover:text-[#887443]"
            >
              Início
            </Link>
            <Link
              to="/we"
              className="block px-10 py-2 text-white hover:text-[#887443]"
            >
              Sobre Nós
            </Link>
            <Link
              to="/cripto"
              className="block px-10 py-2 text-white hover:text-[#887443]"
            >
              Exchange
            </Link>
            <Link
              to="/token"
              className="block px-10 py-2 text-white hover:text-[#887443]"
            >
              Investimento
            </Link>
            <a
              onClick={openMainModal}
              className="bg-white text-black px-10 py-2 rounded-full font-bold my-2 mx-10"
            >
              Entrar em contato
            </a>
            <a
              target="_blank"
              href="https://banking.wiiascend.com/"
              className="bg-transparent font-bold text-center justify-center border border-[#1553E099]/60 text-white px-10 py-2 rounded-full my-1 mx-10"
            >
              Login
            </a>
          </div>
        )}
      </div>

      <Contact isOpen={isModalOpen} closeModal={closeModal} />
      <OptionModal isOpen={isMainModalOpen} closeModal={closeMainModal} />
    </>
  );
};

export default Header;
